import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCommon from '@/i18n/locales/en/common.json';
import fiCommon from '@/i18n/locales/fi/common.json';

const savedLanguage = localStorage.getItem('varauslite-language') ?? 'fi';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon },
      fi: { common: fiCommon },
    },
    lng: savedLanguage,
    fallbackLng: 'fi',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
